import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";
import { API } from "../config";
import { getCookie, userSessionExpired } from "./auth";

const Jobs = () => {
    const history = useHistory();

    const addJob = (job) => {
        return fetch(`${API}/add-job`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(job),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const getJobs = () => {
        return fetch(`${API}/get-jobs`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const getUserJobs = (email) => {
        const query = email ? `?email=${encodeURIComponent(email)}` : "";
        return fetch(`${API}/get-user-jobs${query}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const deleteJob = (Id) => {
        return fetch(`${API}/delete-job/${Id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const updateJob = (job, Id) => {
        return fetch(`${API}/update-job/${Id}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(job),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const adminApproveJob = (Id) => {
        return fetch(`${API}/admin-approve-job/${Id}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const getApprovedCompanyJobs = (companyId) => {
        return fetch(`${API}/get-approved-company-jobs/${companyId}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const userAddJob = (job, companyId) => {
        return fetch(`${API}/user-add-job/${companyId}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(job),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const approveJob = (Id) => {
        return fetch(`${API}/approve-job/${Id}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const rejectJob = (Id) => {
        return fetch(`${API}/reject-job/${Id}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const getAllJobsForAdmin = () => {
        return fetch(`${API}/admin/all-jobs`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    return {
        addJob,
        userAddJob,
        getJobs,
        getUserJobs,
        deleteJob,
        updateJob,
        adminApproveJob,
        getApprovedCompanyJobs,
        approveJob,
        rejectJob,
        getAllJobsForAdmin,
    };
};

export default Jobs;
